const calcDays = async (createdAt: Date) => {
    const timeElapsed = Date.now();
    const diffInMs    = Number(new Date(createdAt)) -  Number(new Date(timeElapsed));
    const diffInDays = diffInMs    / (1000 * 60 * 60 * 24);
    const days = Math.abs(Math.round(diffInDays));

    return days;
}

export default calcDays;